module.exports = __webpack_public_path__ + "assets/Robbery.9fd6678f.svg";